<agmo-loading *ngIf="isLoading"></agmo-loading>

<ng-container *ngIf="!isLoading && (notFound || (summary && !hasSummary))">
  <div class="container tw-py-8">
    <div class="empty-state text-center py-5">
      <h3>{{ 'campaignSummary.notAvailable' | translate }}</h3>
      <p class="text-muted">{{ 'campaignSummary.notAvailableDesc' | translate }}</p>
      <button class="btn btn-primary mt-3" (click)="findOutMore()">
        {{ 'campaignSummary.viewCampaign' | translate }}
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading && summary && hasSummary && statusConfig">
  <div class="page" [class.is-prelive]="isPreLiveTemplate">
    <div class="toolbar-row">
      <product-badge></product-badge>
      <button class="share-btn" (click)="shareCampaign()" aria-label="Share">
        <span class="pitchin-icon-share share-btn__icon"></span>
      </button>
    </div>

    <div class="hero-wrap">
      <div class="promo-banner" *ngIf="summary.highlightTitle || summary.highlightBody">
        <strong *ngIf="summary.highlightTitle">{{ summary.highlightTitle }}</strong>
        <span class="promo-banner__body" *ngIf="summary.highlightBody">{{ summary.highlightBody }}</span>
        <a *ngIf="summary.highlightUrl" [href]="summary.highlightUrl" target="_blank" rel="noopener noreferrer" class="promo-banner__link">{{ 'campaignSummary.findOutMore' | translate }}</a>
      </div>

      <div class="top-card">
        <div class="top-card-left">
          <ng-container *ngIf="!isPreLiveTemplate">
            <ng-container *ngTemplateOutlet="brandLogo"></ng-container>
          </ng-container>

          <ng-container *ngIf="isPreLiveTemplate">
            <div class="top-card-prelive-group">
              <ng-container *ngTemplateOutlet="brandLogo"></ng-container>
              <div class="top-card-mid">
                <ng-container *ngTemplateOutlet="statusBadge"></ng-container>
                <div class="metric-label prelive-desktop">{{ 'campaignSummary.minTargetLabel' | translate }}</div>
                <div class="metric-label prelive-mobile">{{ 'campaignSummary.minTargetShort' | translate }}</div>
                <div class="metric-value">{{ metricValue }}</div>
                <div class="metric-of prelive-mobile" *ngIf="summary.maximumTargetAmount > 0">
                  {{ 'campaignSummary.ofAmount' | translate }} {{ amount(summary.maximumTargetAmount) }}
                </div>
                <div class="metric-sub prelive-mobile">{{ 'campaignSummary.acceptingReservations' | translate }}</div>
              </div>
            </div>

            <div class="metric-sub prelive-desktop">{{ 'app.reserveSpot' | translate }}</div>

            <div class="top-card-investment-terms">
              <div class="terms-floating" [class.is-open]="!isInvestmentTermsCollapsed">
                <div
                  class="terms-header"
                  role="button"
                  tabindex="0"
                  [attr.aria-expanded]="!isInvestmentTermsCollapsed"
                  (click)="toggleInvestmentTerms()"
                  (keydown.enter)="toggleInvestmentTerms()"
                  (keydown.space)="$event.preventDefault(); toggleInvestmentTerms()"
                >
                  {{ 'campaign.investmentTerms' | translate }}
                  <span class="chev" [class.is-open]="!isInvestmentTermsCollapsed">
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" aria-hidden="true">
                      <path d="M1.5 1.5L7 6.5L12.5 1.5" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                </div>
                <div class="terms-body" [hidden]="isInvestmentTermsCollapsed">
                  <ng-container *ngTemplateOutlet="termsRows"></ng-container>
                </div>
              </div>
            </div>

            <div class="top-card-ctas">
              <button class="btn-primary" (click)="investNow()">{{ statusConfig.primaryText | translate }}</button>
              <button class="btn-secondary" (click)="findOutMore()">{{ 'campaignSummary.findOutMore' | translate }}</button>
            </div>
          </ng-container>

          <ng-container *ngIf="summary.campaignStatus === CampaignStatus.Live || summary.campaignStatus === CampaignStatus.Cooling">
            <div class="top-card-mid">
              <ng-container *ngTemplateOutlet="statusBadge"></ng-container>
              <div class="metric-label card-desktop-only">{{ statusConfig.metricLabel | translate }}</div>
              <div class="metric-label card-mobile-only">{{ 'campaignSummary.minTargetShort' | translate }}</div>
              <div class="metric-value" [ngClass]="metricValueSizeClass">{{ metricValue }}</div>
              <!-- Phones only: the ring and stat tiles are hidden there, so the target
                   and minimum ticket move into the card instead. -->
              <div class="metric-of card-mobile-only" *ngIf="summary.minimumTargetAmount > 0">
                {{ 'campaignSummary.ofAmount' | translate }} {{ amount(summary.minimumTargetAmount) }}
              </div>
              <div class="metric-mininv card-mobile-only"
                   *ngIf="summary.minimumLots && summary.sharePerLot && summary.pricePerShare">
                {{ 'campaignSummary.minInvestment' | translate }}: {{ amount(summary.minimumLots * summary.sharePerLot * summary.pricePerShare) }}
              </div>
            </div>

            <ng-container *ngTemplateOutlet="statsRow"></ng-container>

            <div class="top-card-investment-terms">
              <div class="terms-floating" [class.is-open]="!isInvestmentTermsCollapsed">
                <div
                  class="terms-header"
                  role="button"
                  tabindex="0"
                  [attr.aria-expanded]="!isInvestmentTermsCollapsed"
                  (click)="toggleInvestmentTerms()"
                  (keydown.enter)="toggleInvestmentTerms()"
                  (keydown.space)="$event.preventDefault(); toggleInvestmentTerms()"
                >
                  {{ 'campaign.investmentTerms' | translate }}
                  <span class="chev" [class.is-open]="!isInvestmentTermsCollapsed">
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" aria-hidden="true">
                      <path d="M1.5 1.5L7 6.5L12.5 1.5" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                </div>
                <div class="terms-body" [hidden]="isInvestmentTermsCollapsed">
                  <ng-container *ngTemplateOutlet="termsRows"></ng-container>
                </div>
              </div>
            </div>

            <div class="top-card-ctas">
              <button class="btn-primary" (click)="investNow()">{{ statusConfig.primaryText | translate }}</button>
              <button class="btn-secondary" (click)="findOutMore()">{{ 'campaignSummary.findOutMore' | translate }}</button>
            </div>
          </ng-container>

          <ng-container *ngIf="isCompletedStage">
            <div class="top-card-mid">
              <ng-container *ngTemplateOutlet="statusBadge"></ng-container>
              <!-- One label at both widths here: a closed campaign reports what it
                   raised. Only Live/Cooling swap in "MIN. TARGET" on phones. -->
              <div class="metric-label">{{ statusConfig.metricLabel | translate }}</div>
              <div class="metric-value" [ngClass]="metricValueSizeClass">{{ metricValue }}</div>
              <!-- Phones only: the ring and stat tiles are hidden there, so the target
                   and the closing note move into the card instead. -->
              <div class="metric-of card-mobile-only" *ngIf="summary.minimumTargetAmount > 0">
                {{ 'campaignSummary.ofAmount' | translate }} {{ amount(summary.minimumTargetAmount) }}
              </div>
              <div class="metric-mininv card-mobile-only">{{ 'campaignSummary.campaignEnded' | translate }}</div>
            </div>

            <ng-container *ngTemplateOutlet="statsRow"></ng-container>

            <div class="top-card-investment-terms">
              <div class="terms-floating" [class.is-open]="!isInvestmentTermsCollapsed">
                <div
                  class="terms-header"
                  role="button"
                  tabindex="0"
                  [attr.aria-expanded]="!isInvestmentTermsCollapsed"
                  (click)="toggleInvestmentTerms()"
                  (keydown.enter)="toggleInvestmentTerms()"
                  (keydown.space)="$event.preventDefault(); toggleInvestmentTerms()"
                >
                  {{ 'campaign.investmentTerms' | translate }}
                  <span class="chev" [class.is-open]="!isInvestmentTermsCollapsed">
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" aria-hidden="true">
                      <path d="M1.5 1.5L7 6.5L12.5 1.5" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                </div>
                <div class="terms-body" [hidden]="isInvestmentTermsCollapsed">
                  <ng-container *ngTemplateOutlet="termsRows"></ng-container>
                </div>
              </div>
            </div>

            <div class="stat-divider"></div>

            <div class="top-card-completed-cta">
              <button class="btn-secondary" (click)="investNow()">{{ statusConfig.primaryText | translate }}</button>
            </div>
          </ng-container>
        </div>
      </div>

      <ng-template #statsRow>
        <div class="stats-row">
          <div class="ring-wrap" [ngClass]="'ring-' + progressColorClass" *ngIf="summary.raisedPercentage != null">
            <svg width="108" height="108" viewBox="0 0 108 108">
              <circle cx="54" cy="54" r="46" stroke="#E7EAEE" stroke-width="8" fill="none"/>
              <circle cx="54" cy="54" r="46" class="ring-progress" stroke-width="8" fill="none"
                [attr.stroke-dasharray]="ringCircumference" [attr.stroke-dashoffset]="ringOffset"
                stroke-linecap="round"/>
            </svg>
            <div class="ring-pct">
              <span class="pct-num">{{ displayPercentLabel }}</span>
              <span class="pct-sub">of {{ targetLabel }}</span>
            </div>
          </div>
          <!-- Shown for the whole of a status, zero included: a live campaign with no
               investors yet reads as "0 INVESTORS", and hiding the tile instead left a
               gap in the stats row. statusConfig.showStats/showDaysLeft still decide
               which statuses get them at all. -->
          <div class="stat-divider" *ngIf="summary.raisedPercentage != null"></div>
          <div class="stat">
            <div class="num">{{ summary.investorCount || 0 }}</div>
            <div class="lbl">{{ 'campaignSummary.investors' | translate }}</div>
          </div>
          <ng-container *ngIf="statusConfig.showDaysLeft">
            <div class="stat-divider"></div>
            <div class="stat days" [ngClass]="'days-' + statusAccentClass">
              <div class="num">{{ summary.daysRemaining || 0 }}</div>
              <div class="lbl">{{ 'campaign.daysLeft' | translate }}</div>
            </div>
          </ng-container>
        </div>
      </ng-template>

      <ng-template #brandLogo>
        <img *ngIf="summary.companyLogoUrl; else logoPlaceholder"
             [src]="getImageUrl(summary.companyLogoUrl)" alt="Logo" class="brand-mark tw-rounded-full tw-object-cover" />
        <ng-template #logoPlaceholder>
          <div class="brand-mark tw-rounded-full tw-bg-gray-200 tw-flex tw-items-center tw-justify-center">
            <span class="tw-text-xl tw-font-bold tw-text-gray-400">{{ summary.companyName?.charAt(0) }}</span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template #statusBadge>
        <span class="badge" [ngClass]="statusConfig.badgeClass">
          <svg *ngIf="isCompletedStage" class="badge-check" width="11" height="9" viewBox="0 0 12 10"
               fill="none" aria-hidden="true">
            <path d="M1.5 5.2L4.4 8L10.5 1.6" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="dot" *ngIf="!isCompletedStage"></span>{{ statusConfig.badgeText | translate }}
        </span>
      </ng-template>

      <ng-template #termsRows>
        <div class="terms-row">
          <span class="k">{{ 'campaignSummary.shareType' | translate }}</span>
          <span class="v">{{ summary.campaignType || 'Equity' }} - {{ shareTypeLabel }}</span>
        </div>
        <div class="terms-row">
          <span class="k">{{ 'campaignSummary.valuation' | translate }}</span>
          <span class="v">{{ amount(summary.valuationAmount) }}</span>
        </div>
        <div class="terms-row">
          <span class="k">{{ 'campaignSummary.target' | translate }}</span>
          <span class="v">{{ amount(summary.minimumTargetAmount) }}</span>
        </div>
        <div class="terms-row last" *ngIf="!isCompletedStage">
          <span class="k">{{ 'campaignSummary.minInvestment' | translate }}</span>
          <span class="v">{{ (summary.minimumLots && summary.sharePerLot && summary.pricePerShare) ? amount(summary.minimumLots * summary.sharePerLot * summary.pricePerShare) : '-' }}</span>
        </div>
      </ng-template>

      <div class="content-row">
        <div class="hero-copy">
          <h1>{{ firstField?.headerName || summary.campaignName }}</h1>
          <!-- `highlightBody` is deliberately not a fallback here: it already renders in
               `.promo-banner` above, so using it would print the same text twice. -->
          <div class="desc" [innerHTML]="firstField?.textContent || summary.companyTagline"></div>
          <div class="tag-row">
            <span class="tag-pill" *ngFor="let sector of visibleSectors">{{ sector.name }}</span>
            <span class="tag-pill" *ngIf="summary?.partnershipBacked"
                  [ngClass]="PartnershipBacked[summary.partnershipBacked]">
              {{ 'campaign.' + PartnershipBacked[summary.partnershipBacked] | translate }}
            </span>
            <span class="tag-pill" *ngFor="let impact of summary?.campaignImpacts"
                  [ngClass]="Impact[impact]">
              {{ 'campaign.' + Impact[impact] | translate }}
            </span>
          </div>
        </div>

        <div class="hero-panel-desktop">
          <!-- no-cta: a completed campaign renders no buttons inside the panel, so the
               padding kept for them becomes dead space under the last row. -->
          <div class="terms-floating" [class.is-open]="!isInvestmentTermsCollapsed"
               [class.no-cta]="isCompletedStage">
            <div
              class="terms-header"
              role="button"
              tabindex="0"
              [attr.aria-expanded]="!isInvestmentTermsCollapsed"
              (click)="toggleInvestmentTerms()"
              (keydown.enter)="toggleInvestmentTerms()"
              (keydown.space)="$event.preventDefault(); toggleInvestmentTerms()"
            >
              {{ 'campaign.investmentTerms' | translate }}
              <span class="chev" [class.is-open]="!isInvestmentTermsCollapsed">
                    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" aria-hidden="true">
                      <path d="M1.5 1.5L7 6.5L12.5 1.5" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
            </div>
            <div class="terms-body" [hidden]="isInvestmentTermsCollapsed">
              <ng-container *ngTemplateOutlet="termsRows"></ng-container>
              <button class="btn-primary desktop-cta" (click)="investNow()" *ngIf="!isCompletedStage">{{ statusConfig.primaryText | translate }}</button>
              <button class="btn-secondary desktop-cta" (click)="findOutMore()" *ngIf="!statusConfig.isFinalState">
                {{ 'campaignSummary.findOutMore' | translate }}
              </button>
            </div>
          </div>
          <div class="side-actions" [hidden]="!isInvestmentTermsCollapsed" *ngIf="!isCompletedStage">
            <button class="btn-primary" (click)="investNow()">{{ statusConfig.primaryText | translate }}</button>
            <button class="btn-secondary" (click)="findOutMore()" *ngIf="!statusConfig.isFinalState">
              {{ 'campaignSummary.findOutMore' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <div class="tw-space-y-8">
      <ng-container *ngFor="let field of fields; trackBy: trackByField">
        <div class="block-section">

          <ng-container *ngIf="field.fieldType === FieldType.description">
            <h2 *ngIf="field.headerName" class="tw-mb-4 tw-text-xl tw-font-bold tw-text-gray-800">{{ field.headerName }}</h2>
            <div class="tw-text-base tw-leading-relaxed tw-text-gray-600" [innerHTML]="field.textContent"></div>
          </ng-container>

          <ng-container *ngIf="field.fieldType === FieldType.text">
            <h2 *ngIf="field.headerName" class="tw-mb-4 tw-text-center tw-text-xl tw-font-bold tw-text-gray-800">{{ field.headerName }}</h2>
            <div class="tw-text-base tw-leading-relaxed tw-text-gray-600" [innerHTML]="field.textContent"></div>
          </ng-container>

          <ng-container *ngIf="field.fieldType === FieldType.carousel">
            <h2 *ngIf="field.headerName" class="tw-mb-4 tw-text-center tw-text-xl tw-font-bold tw-text-gray-800">{{ field.headerName }}</h2>
            <div class="carousel-container">
              <iframe
                [src]="getSafeUrl(field.slideUrl)"
                [title]="field.headerName || 'Carousel'"
                loading="lazy"
                frameborder="0"
                allow="fullscreen"
                class="block-carousel"
                allowfullscreen
                tabindex="0"
                (focus)="onCarouselClick(field)"
              ></iframe>
            </div>
          </ng-container>

          <ng-container *ngIf="field.fieldType === FieldType.highlights">
            <h2 *ngIf="field.headerName" class="tw-mb-6 tw-text-center tw-text-xl tw-font-bold tw-text-gray-800">{{ field.headerName }}</h2>
            <div class="highlights-grid">
              <div class="info-card" *ngFor="let hl of field.keyHighlights" [style.background]="hl.backgroundColor || '#fff'">
                <div class="info-card-icon">
                  <i class="fa" [ngClass]="getIconName(hl.iconName)"></i>
                </div>
                <h3>{{ hl.titleText }}</h3>
                <p>{{ hl.detailText }}</p>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="field.fieldType === FieldType.image">
            <h2 *ngIf="field.headerName" class="tw-mb-4 tw-text-center tw-text-xl tw-font-bold tw-text-gray-800">{{ field.headerName }}</h2>
            <img [src]="getImageUrl(field.textContent)" [alt]="field.headerName" class="tw-w-full tw-rounded-lg tw-object-cover" style="max-height: 480px;" />
          </ng-container>

          <ng-container *ngIf="field.fieldType === FieldType.video">
            <h2 *ngIf="field.headerName" class="tw-mb-4 tw-text-center tw-text-xl tw-font-bold tw-text-gray-800">{{ field.headerName }}</h2>
            <ng-container *ngIf="getVideoEmbedUrl(field.textContent) as videoUrl; else videoFallback">
              <div class="video-container">
                <iframe [src]="videoUrl" [title]="field.headerName || 'Video'" loading="lazy" frameborder="0" allowfullscreen class="block-video"></iframe>
              </div>
              <a [href]="getWatchUrl(field.textContent)" target="_blank" rel="noopener noreferrer" class="tw-text-sm tw-text-primary tw-underline tw-mt-2 tw-inline-block">Watch video ↗</a>
            </ng-container>
            <ng-template #videoFallback>
              <a [href]="getWatchUrl(field.textContent)" target="_blank" rel="noopener noreferrer" class="tw-text-primary tw-underline">Watch video ↗</a>
            </ng-template>
          </ng-container>

        </div>
      </ng-container>
    </div>
  </div>

  <div class="sticky-bar" [class.is-prelive]="isPreLiveTemplate" [class.is-expanded]="isMobileExpanded" #stickyBarRef>
    <!-- Everything above the CTA row scrolls together when the bar is capped, so the
         buttons stay pinned and tappable however little height the bar is given. -->
    <div class="sticky-scroll">
      <div class="sticky-summary">
        <div class="sticky-top-row">
          <span class="badge" [ngClass]="statusConfig.badgeClass">
            <svg *ngIf="isCompletedStage" class="badge-check" width="11" height="9" viewBox="0 0 12 10"
                 fill="none" aria-hidden="true">
              <path d="M1.5 5.2L4.4 8L10.5 1.6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="dot" *ngIf="!isCompletedStage"></span>{{ statusConfig.badgeText | translate }}
          </span>
          <span class="sticky-amt-inline" [ngClass]="metricValueSizeClass"
                *ngIf="!isPreLiveTemplate && !isMobileExpanded && !isCompletedStage">
            {{ metricValue }}<span class="sticky-amt-suffix">{{ 'campaignSummary.raised' | translate }}</span>
          </span>
          <button class="chevbtn" [class.points-up]="!isMobileExpanded" (click)="toggleMobileExpanded()"
                  [attr.aria-expanded]="isMobileExpanded">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" aria-hidden="true">
              <path d="M1.5 1.5L7 6.5L12.5 1.5" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>

        <ng-container *ngIf="isPreLiveTemplate">
          <div class="sticky-label">{{ 'campaignSummary.minTargetLabel' | translate }}</div>
          <div class="sticky-row-between sticky-amt-row">
            <span class="sticky-amt-big">{{ metricValue }}</span>
            <span class="sticky-tag">{{ 'campaign.launchingSoon' | translate }}</span>
          </div>
        </ng-container>

        <!-- Completed and collapsed: the raise is over, so the headline is the result with
             the investor count beside it. No progress bar or "% funded" — there is nothing
             left to fill. -->
        <ng-container *ngIf="isCompletedStage && !isMobileExpanded">
          <div class="sticky-label">{{ (statusConfig.collapsedLabel || statusConfig.metricLabel) | translate }}</div>
          <div class="sticky-row-between sticky-amt-row">
            <span class="sticky-amt-big">{{ metricValue }}</span>
            <span class="sticky-stats-left">
              <svg class="sticky-stats-icon" width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <circle cx="6.2" cy="5" r="2.6" stroke="currentColor" stroke-width="1.4" />
                <path d="M1.8 13.2c0-2.4 2-4.1 4.4-4.1s4.4 1.7 4.4 4.1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
                <path d="M11.2 4.3a2.2 2.2 0 0 1 0 4.2M14.2 13.2c0-1.7-.7-2.8-1.9-3.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
              </svg>
              <span>{{ (summary.investorCount || 0) + ' ' + ('campaignSummary.investors' | translate) }}</span>
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="!isPreLiveTemplate && isMobileExpanded">
          <div class="sticky-amt-expanded">{{ metricValue }}</div>
          <div class="sticky-row-between sticky-target-row">
            <span class="sticky-target">
              {{ 'campaignSummary.ofAmount' | translate }} {{ 'campaignSummary.minTargetShort' | translate }} ({{ amount(summary.minimumTargetAmount) }})
            </span>
            <span class="sticky-days-pill" *ngIf="statusConfig.showDaysLeft"
                  [ngClass]="'pill-' + statusAccentClass">
              <svg width="13" height="13" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                <circle cx="7" cy="7" r="5.6" stroke="currentColor" stroke-width="1.4" />
                <path d="M7 4v3.2l2 1.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              {{ (summary.daysRemaining || 0) + ' ' + ('campaign.daysLeft' | translate) }}
            </span>
          </div>
        </ng-container>

        <ng-container *ngIf="!isPreLiveTemplate && !(isCompletedStage && !isMobileExpanded)">
          <div class="sticky-row-between sticky-stats">
            <span class="sticky-stats-left">
              <svg class="sticky-stats-icon" width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <circle cx="6.2" cy="5" r="2.6" stroke="currentColor" stroke-width="1.4" />
                <path d="M1.8 13.2c0-2.4 2-4.1 4.4-4.1s4.4 1.7 4.4 4.1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
                <path d="M11.2 4.3a2.2 2.2 0 0 1 0 4.2M14.2 13.2c0-1.7-.7-2.8-1.9-3.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
              </svg>
              <span>{{ (summary.investorCount || 0) + ' ' + ('campaignSummary.investors' | translate) }}<ng-container *ngIf="statusConfig.showDaysLeft && !isMobileExpanded"> &bull; {{ (summary.daysRemaining || 0) + ' ' + ('campaign.daysLeft' | translate) }}</ng-container></span>
            </span>
            <span class="sticky-funded" *ngIf="summary.raisedPercentage != null">{{ displayPercentLabel }} funded</span>
          </div>
          <div class="progress-track" [ngClass]="'progress-' + progressColorClass">
            <div class="progress-fill" [style.width.%]="displayPercent"></div>
          </div>
        </ng-container>
      </div>

      <div class="sticky-terms-panel" [hidden]="!isMobileExpanded">
        <ng-container *ngIf="isPreLiveTemplate">
          <div class="sticky-investment-terms">
            <div><div class="k">{{ 'campaignSummary.shareType' | translate }}</div><div class="v">{{ summary.campaignType || 'Equity' }} - {{ shareTypeLabel }}</div></div>
            <div><div class="k">{{ 'campaignSummary.valuation' | translate }}</div><div class="v">{{ amount(summary.valuationAmount) }}</div></div>
            <div class="closing"><div class="k">{{ 'campaignSummary.minInvestment' | translate }}</div><div class="v">{{ (summary.minimumLots && summary.sharePerLot && summary.pricePerShare) ? amount(summary.minimumLots * summary.sharePerLot * summary.pricePerShare) : '-' }}</div></div>
          </div>
        </ng-container>
        <ng-container *ngIf="!isPreLiveTemplate">
          <div class="sticky-terms">
            <div><div class="k">{{ 'campaignSummary.shareType' | translate }}</div><div class="v">{{ summary.campaignType || 'Equity' }} - {{ shareTypeLabel }}</div></div>
            <div><div class="k">{{ 'campaignSummary.valuation' | translate }}</div><div class="v">{{ amount(summary.valuationAmount) }}</div></div>
            <!-- Nothing left to invest once the raise has closed. -->
            <div class="closing" *ngIf="!isCompletedStage"><div class="k">{{ 'campaignSummary.minInvestment' | translate }}</div><div class="v">{{ (summary.minimumLots && summary.sharePerLot && summary.pricePerShare) ? amount(summary.minimumLots * summary.sharePerLot * summary.pricePerShare) : '-' }}</div></div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="sticky-btnrow">
      <button class="btn-secondary" (click)="findOutMore()" *ngIf="!statusConfig.isFinalState">{{ 'campaignSummary.findOutMore' | translate }}</button>
      <button [class]="isCompletedStage ? 'btn-secondary' : 'btn-primary'" (click)="investNow()">{{ statusConfig.primaryText | translate }}</button>
    </div>
  </div>
</ng-container>
